import React, { useCallback, useSyncExternalStore } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import InlineBox from '$/components/InlineBox';
import { IInlineBox, IInlineBoxConfig, InlineBoxUpdateType } from '$/components/InlineBox/types';
import {
  getInlineBoxRuntimeState,
  subscribeInlineBoxRuntimeState,
} from '../inlineBoxStateStore';
import { useInputTextAreaContext } from '../context';

export default function InlineboxEditer({
  inlineBox,
  nodeKey,
}: {
  inlineBox: IInlineBox;
  nodeKey?: string;
}) {
  const [editor] = useLexicalComposerContext();
  const { renderMarkPopover, onInlineBoxClick, getMarkResults } = useInputTextAreaContext();

  // 订阅外置的运行时态（选中/加载中），不进 EditorState，不参与撤销重做。
  const subscribe = useCallback(
    (listener: () => void) => subscribeInlineBoxRuntimeState(editor, nodeKey || '', listener),
    [editor, nodeKey],
  );
  const getSnapshot = useCallback(
    () => getInlineBoxRuntimeState(editor, nodeKey || ''),
    [editor, nodeKey],
  );
  const runtimeState = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  const config: IInlineBoxConfig = {
    [InlineBoxUpdateType.Loading]: runtimeState.loading,
    [InlineBoxUpdateType.Selected]: runtimeState.selected,
  };

  const markResultList = nodeKey && getMarkResults ? getMarkResults(nodeKey) : undefined;

  /** 将 InlineBox 内部点击事件转换为与 MediaInput 预览项一致的数据回调。 */
  const handleInlineBoxClick = useCallback(() => {
    onInlineBoxClick?.(inlineBox.data);
  }, [inlineBox.data, onInlineBoxClick]);

  return (
    <InlineBox
      inlineBox={inlineBox}
      config={config}
      nodeKey={nodeKey}
      editor={editor}
      clickable
      renderMarkPopover={renderMarkPopover}
      markResultList={markResultList}
      onClick={handleInlineBoxClick}
    />
  );
}
